import { useEffect, useState } from 'react'
import { getActiveBookingCount } from './api'
import { onBookingsChanged } from './bookingSignal'

/** Small project-wide count, independent of the calendar's visible date range. */
export function useActiveBookingCount(projectId: string, token: string, enabled: boolean): number | null {
  const [result, setResult] = useState<{ projectId: string; token: string; count: number } | null>(null)
  useEffect(() => {
    if (!enabled) return
    let alive = true
    let version = 0
    const refresh = () => {
      const requested = ++version
      void getActiveBookingCount(projectId, token).then(({ count }) => {
        if (alive && requested === version) setResult({ projectId, token, count })
      }).catch(() => {})
    }
    refresh()
    const visibleRefresh = () => { if (!document.hidden) refresh() }
    const timer = window.setInterval(visibleRefresh, 60_000)
    window.addEventListener('focus', visibleRefresh)
    document.addEventListener('visibilitychange', visibleRefresh)
    const unsubscribe = onBookingsChanged((changed) => { if (changed === projectId) refresh() })
    return () => {
      alive = false
      window.clearInterval(timer)
      window.removeEventListener('focus', visibleRefresh)
      document.removeEventListener('visibilitychange', visibleRefresh)
      unsubscribe()
    }
  }, [projectId, token, enabled])
  return enabled && result?.projectId === projectId && result.token === token ? result.count : null
}
